import {
  LandingPageOptions,
  SetupListNavInfoByDepartment,
  NavItem,
} from "../../../../types";
import { DEPENDENT_SETUPS_MAP } from "../../constants";

export const getHeaderSetupsList = ({
  selected,
  setupListNavInfoByDepartment,
}: {
  selected: LandingPageOptions;
  setupListNavInfoByDepartment: SetupListNavInfoByDepartment;
}): { setupsOptions: NavItem[]; subGroup: string | null } => {
  const departmentKey = selected.department.value;
  const setupId = selected.setup.value;

  const subgroups = DEPENDENT_SETUPS_MAP.get(departmentKey);
  const setups = setupListNavInfoByDepartment?.[departmentKey]?.setups || null;

  if (!subgroups || !setups) return { setupsOptions: [], subGroup: null };

  const setupSubgroup =
    subgroups.find((sg) => sg.setupsList.includes(setupId)) || null;

  if (!setupSubgroup) return { setupsOptions: [], subGroup: null };

  const setupsOptions = setupSubgroup.setupsList
    .map((id) => setups.find((setup) => setup.id === id))
    .filter((item): item is NavItem => item !== undefined);

  return { setupsOptions, subGroup: setupSubgroup.text };
};
